<script>
  import Vue from 'vue'
  import api from '../api'
  import PhotoCard from '../components/PhotoCard'
  import AddPhotos from '../components/AddPhotos'
  import SendClientNotification from '../components/SendClientNotification'
  import DownloadPhotos from '../components/DownloadPhotos'
  import { mapState } from 'vuex'
  
  export default {
    created () {
      this.fetchAddress()
    },

    components: {
      PhotoCard,
      AddPhotos,
      SendClientNotification,
      DownloadPhotos
    },

    computed: {
      ...mapState(['user'])
    },

    data () {
      return {
        address: {},
        showAddPhotos: false
      }
    },

    methods: {
      async fetchAddress () {
        let response = await api.apios.get(`/api/addresses/${this.$route.params.id}`)

        this.address = response.data
      }
    }
  }
</script>

<template>
  <section class="section">
    <div class="container">

      <h1 class="title">{{ address.name }}</h1>
      
      <add-photos v-if="showAddPhotos" :address="address" @refresh="fetchAddress"></add-photos>
      
      <div class="is-clearfix">
        <send-client-notification v-if="user.gates['send-notification']" :address="address"></send-client-notification>

        <download-photos :address="address"></download-photos>

        <a v-if="user.gates['address-photos.create']" @click="showAddPhotos = !showAddPhotos" class="button is-primary">
          <span class="icon is-small">
            <i class="fa fa-plus"></i>
          </span>
          <span>Add Photos</span>
        </a>
      </div>

      <hr />

      <div class="columns is-multiline">
        <div class="column is-one-third" v-for="photo in address.photos">
          <photo-card :photo="photo" @refresh="fetchAddress"></photo-card>
        </div>
      </div>
    </div>
  </section>
</template>